import { Commission } from 'src/models/commission.model';
import TimesheetTableRow from './timesheet-table-row';
import styles from './timesheet-table.module.scss';

type Props = {
  month: number;
  days: number;
  year: number;
  commissions: Commission[];
};

const TimesheetTableBody = (props: Props) => {
  const { month, days, year, commissions } = props;

  const sortedCommissions = [...commissions].sort((a, b) => {
    const priorityNames = ['ferie', 'malattia', 'permessi', 'lutto'];
    const aName = a.commissionName.toLowerCase();
    const bName = b.commissionName.toLowerCase();

    if (aName === 'smartworking') return 1;
    if (bName === 'smartworking') return -1;

    const aIsPriority = priorityNames.includes(aName);
    const bIsPriority = priorityNames.includes(bName);

    if (aIsPriority && !bIsPriority) return 1;
    if (!aIsPriority && bIsPriority) return -1;
    return 0;
  });

  return (
    <tbody className={styles.tableBodyContainer}>
      {sortedCommissions.map(commission => (
        <TimesheetTableRow key={commission.id} commission={commission} days={days} year={year} month={month} />
      ))}
    </tbody>
  );
};

export default TimesheetTableBody;
